<div class="container-fluid mb-3">
  <div class="row">
    <div class="col-12">
      <ng-container *ngIf="saved">
        <mat-icon class="mt-1">done</mat-icon>
      </ng-container>
    </div>
    <div class="col-4">
      <p><strong>Albarán</strong></p>
    </div>
    <div class="col-8">
      <button mat-stroked-button class="btn-convfact  me-3 pull-right" (click)="save(deliverynote)">
        <mat-icon>save</mat-icon>
        Guardar
      </button>
    </div>
  </div>
  <hr>
</div>

<ng-container *ngIf="ready">
  <div class="bg-white">
    <mat-card appearance="outlined">
      <div class="mainBody">

        <button mat-stroked-button (click)="newContact(false)" class="mb-3">Nuevo contacto</button>
        <span *ngIf="(newContactLoaded | async) === null" class="ms-3">
          No se ha podido obtener la lista de contactos actualizada
        </span>

        <div class="flex-container">
          <div class="two-column">
            <div class="w-100">

              <div style="width: 90%;">
                <app-autocomplete-select [items]="contactList" placeholder="Contactos" [idField]="'companyName'"
                  [(selectedItemId)]="deliverynote.receiverName" [displayField]="'companyName'"
                  (selectionChanged)="onSelectContact($event)" [classList]="'width90'">
                </app-autocomplete-select>
                <app-help key='Ingresos7'></app-help>
              </div>

              <ng-container *ngIf="centers.length > 0">
                <div class="w-100">
                  <app-select name="deliverynote.centerUid" [(ngModel)]="deliverynote.centerUid"
                    [ngModelOptions]="{standalone: true}" [config]="{ label: 'Centro', options: centerOptions }">
                  </app-select>
                </div>
              </ng-container>

              <div class="w-100">
                <mat-form-field class="inputWithHelp">
                  <input type="text" matInput placeholder="Número Albarán" name="deliverynote.preInvoiceNumber" required
                    [(ngModel)]="deliverynote.preInvoiceNumber" [readonly]="true">
                </mat-form-field>
                <app-help key='Ingresos8'></app-help>
              </div>

              <div class="w-100">
                <mat-checkbox [checked]="deliverynote.useDeliverAddress" (change)="toggleUseDeliverAddress($event)">
                  Usar domicilio de entrega
                </mat-checkbox>
              </div>
              <div class="w-100">
                <mat-checkbox [checked]="deliverynote.conditions" (change)="onConditionsChange($event)">
                  Mostrar condiciones de pago
                </mat-checkbox>
              </div>
              <br />

              <div class="w-100">
                <mat-form-field class="inputWithHelp">
                  <input matInput [matDatepicker]="invoiceRelease" placeholder="Fecha creación"
                    name="deliverynote.invoiceRelease" weekStart=1 [(ngModel)]="deliverynote.invoiceRelease"
                    (dateInput)="setExpiration($event)" (dateChange)="setExpiration($event)" required>
                  <mat-datepicker-toggle matSuffix [for]="invoiceRelease"></mat-datepicker-toggle>
                  <mat-datepicker #invoiceRelease></mat-datepicker>
                </mat-form-field>
                <app-help key='Ingresos9'></app-help>
              </div>

              <div class="w-100">
                <mat-form-field class="inputWithHelp">
                  <input matInput [matDatepicker]="invoiceExpiration" placeholder="Fecha vencimiento"
                    name="deliverynote.invoiceExpiration" [(ngModel)]="deliverynote.invoiceExpiration" required>
                  <mat-datepicker-toggle matSuffix [for]="invoiceExpiration"></mat-datepicker-toggle>
                  <mat-datepicker #invoiceExpiration></mat-datepicker>
                </mat-form-field>
                <app-help key='Ingresos12'></app-help>
              </div>

            </div>
          </div>
          <div class="two-column">
            <div class="w-100">
              <mat-form-field class="inputWithHelp">
                <input matInput [(ngModel)]="deliverynote.entranceAccount" name="deliverynote.entranceAccount"
                  value="deliverynote.entranceAccount" placeholder="Cuenta contable de ingreso"
                  [matAutocomplete]="autoI" [formControl]="entranceCtrl" required>
                <mat-autocomplete #autoI="matAutocomplete" class="entrance-account-mat-autocomplete"
                  classList="entrance-account-mat-autocomplete">
                  <mat-option *ngFor="let account of filteredEntrances | async; trackBy: trackByIndex" [value]="account.number">
                    <span>{{ account.number }} - {{ account.name }}</span>
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <app-help key='Ingresos14'></app-help>

              <mat-form-field class="inputWithoutHelp" *ngIf="showNumberKilometer">
                <input matInput [(ngModel)]="deliverynote.numberKilometers" name="deliverynote.numberKilometers"
                  value="deliverynote.numberKilometers" placeholder="Nº de Kilómetros" type="textbox"
                  numberDecimalsDirective>
              </mat-form-field>

              <app-autocomplete-select [items]="billMethods" [(selectedItemId)]="deliverynote.typePay" [idField]="'id'"
                [displayField]="'data'" placeholder="Tipo de cobro">
              </app-autocomplete-select>

              <!-- Efectivo -->
              <ng-container *ngIf="deliverynote.typePay === 'Efectivo'">
                <app-autocomplete-select [items]="efectivoList" [(selectedItemId)]="deliverynote.efectivoId"
                  [idField]="'uid'" [displayField]="'nombre'" placeholder="Caja/Efectivo">
                </app-autocomplete-select>
              </ng-container>


              <!-- Socio -->
              <ng-container *ngIf="deliverynote.typePay === 'Socio'">
                <app-autocomplete-select [items]="sociosList" [(selectedItemId)]="deliverynote.partnersId"
                  [idField]="'uid'" [displayField]="'nameOrBusinessName'" placeholder="Socios">
                </app-autocomplete-select>
              </ng-container>

              <ng-container *ngIf="deliverynote.typePay === 'Transferencia bancaria'
              || deliverynote.typePay === 'Remesa en cuenta'
              || deliverynote.typePay === 'Tarjeta'
              || deliverynote.typePay === 'Confirming'
              || deliverynote.typePay === 'Pagarés'">
                <app-autocomplete-select [items]="bankAccounts" [(selectedItemId)]="deliverynote.typePayBankAccount"
                  [idField]="'uid'" [displayFields]="['bank', 'iban']" placeholder="Cuentas bancarias">
                </app-autocomplete-select>
              </ng-container>

              <div *ngIf="isProjectEnable && projects?.length > 0">
                <app-autocomplete-select [items]="projects" [(selectedItemId)]="deliverynote.projectUid"
                  [idField]="'id'" [displayField]="'display'" placeholder="Proyecto">
                </app-autocomplete-select>
              </div>


              <mat-form-field class="inputWithHelp mt-3">
                <textarea [(ngModel)]="deliverynote.comments" name="deliverynote.comments" matInput
                  placeholder="Comentarios" class="inputTextArea"></textarea>
              </mat-form-field>
              <app-help key='Ingresos10'></app-help>

            </div>
          </div>
        </div>

        <hr>

        <div class="row">
          <app-help key='Ingresos13'></app-help>
          <div class="col-md-12 pull-left">
            <button mat-stroked-button (click)="addInvoiceLine()" class="mb-md-0 pull-left"
              style="margin-bottom: 1rem!important;">
              <mat-icon>add</mat-icon> Añadir concepto
            </button>
            <table class="table table-striped table-responsive">
              <thead class="table-dark">
                <tr>
                  <th scope="col" style="width: 30%;">Concepto</th>
                  <th scope="col" style="width: 10%;">Unidades</th>
                  <th scope="col" style="width: 10%;">Precio</th>
                  <th scope="col" style="width: 15%;">Descuento (%)</th>
                  <th scope="col" style="width: 20%;">Impuestos</th>
                  <!-- <th scope="col" style="width: 10%;">Código tarifa</th> -->
                  <th scope="col" style="width: 15%;">Total linea</th>
                  <th scope="col" style="width: 5%;"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of deliverynote.invoiceLines; index as i; trackBy: trackByIndex">
                  <td>
                    <div>{{ item.product }}</div>
                  </td>
                  <td>
                    <div>{{ item.quantity }}</div>
                  </td>
                  <td>
                    <div>{{ item.unityAmount }}</div>
                  </td>
                  <td>
                    <div>{{ item.discount }}</div>
                  </td>
                  <td>
                    <div>{{ getStrTaxes(item.taxes) }}</div>
                  </td>
                  <!-- <td>
                    <div>{{ item.conceptCode }}</div>
                  </td> -->
                  <td>
                    {{calcularTotalesLinea(item)}}
                  </td>
                  <td>
                    <a (click)="toggleEditMode(i)">
                      <mat-icon>edit</mat-icon>
                    </a>
                    <a (click)="removeInvoiceLine(item)">
                      <mat-icon>delete</mat-icon>
                    </a>
                  </td>
                </tr>
              </tbody>
              <!-- Footer -->
              <tfoot>
                <tr>
                  <td colspan="5">
                    <strong>Resumen</strong>
                  </td>
                  <td colspan="1">
                    Subtotal: {{calcularSubtotal()}}

                    <ng-container *ngFor="let taxView of taxesToTheView; trackBy: trackByIndex">
                      <br />{{taxView}}
                    </ng-container>
                    <br />

                    Total: {{calcularTotal()}}
                  </td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
          <!-- <div class="col-md-12 pull-left">
            <button type="button" mat-stroked-button (click)="save(deliverynote)" class="pull-right">
              <mat-icon>save</mat-icon>
              Guardar
            </button>
          </div> -->
        </div>

        <!-- <div class="flex-container">
          <div class="two-column">
            <div class="conceptsList mb-3 scrollbar-primary">
              <app-help key='Ingresos13'></app-help>
              <div *ngFor="let item of deliverynote.invoiceLines; index as i; trackBy: trackByIndex">
                <convfact-preinvoice-form-item [taxes]="accountsAndTaxes.taxes" [item]="item" [concepts]="concepts">
                </convfact-preinvoice-form-item>
                <button mat-stroked-button (click)="removeInvoiceLine(item)" class="mb-3">
                  <mat-icon>delete</mat-icon>Borrar
                </button>
                <hr>
              </div>
            </div>
          </div>

          <div class="two-column">
            <button mat-stroked-button (click)="addInvoiceLine()" class="me-3 mb-2 mb-md-0">
              <mat-icon>add</mat-icon> Añadir concepto
            </button>

            <button type="button" mat-stroked-button [disabled]="deliverynoteService.saveRequestObservable$ | async"  (click)="save(deliverynote)">
              <mat-icon>save</mat-icon>
              Guardar
              <mat-icon *ngIf="deliverynoteService.saveRequestObservable$ | async" class="cf-spin-icon">autorenew</mat-icon>
            </button>

            <br />

            <div class="mt-3">
              <label>
                <strong>Resumen</strong>
              </label>
              <div>
                Subtotal: {{calcularSubtotal()}}
                <br />

                <ng-container *ngFor="let taxView of taxesToTheView; trackBy: trackByIndex">
                  {{taxView}}
                  <br />
                </ng-container>

                Total: {{calcularTotal()}}
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </mat-card>
  </div>
</ng-container>

<ng-container *ngIf="!ready">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>